import type { Invoice, Payment } from '../types';
import {
  clientReceivableEquivalentARS,
  clientOverdueEquivalentARS,
  totalAccountsReceivableFromClientPages,
  totalAccountsOverdueFromClientPages,
} from './clientAccountBalance';

type InvoiceWithBalance = Invoice & { balance?: number };

/**
 * Cuentas por cobrar: suma del equivalente ARS del "saldo actual" de cada ficha de cliente
 * (misma base que ClientAccount: ARS + USD con tipo de las facturas USD).
 */
export function totalAccountsReceivableARS(
  clients: { id: string }[],
  invoices: Invoice[],
  payments: Payment[]
): number {
  return totalAccountsReceivableFromClientPages(clients, invoices, payments);
}

/** Equivalente ARS del saldo actual del cliente (como en su página). */
export function clientAccountsReceivableARS(
  clientId: string,
  invoices: Invoice[],
  payments: Payment[]
): number {
  return clientReceivableEquivalentARS(clientId, invoices, payments);
}

/** Total saldo vencido clientes en ARS equivalente. */
export function totalAccountsOverdueARS(
  clients: { id: string }[],
  invoices: Invoice[],
  payments: Payment[]
): number {
  return totalAccountsOverdueFromClientPages(clients, invoices, payments);
}

/** Equivalente ARS del saldo vencido del cliente. */
export function clientAccountsOverdueARS(
  clientId: string,
  invoices: Invoice[],
  payments: Payment[]
): number {
  return clientOverdueEquivalentARS(clientId, invoices, payments);
}

/** Total cuentas por pagar: suma de saldos pendientes por factura de proveedores en ARS. */
export function totalAccountsPayableARS(invoices: InvoiceWithBalance[]): number {
  return invoices
    .filter(
      (inv) =>
        inv.entity_type === 'supplier' &&
        !inv.voided &&
        inv.entity_id &&
        (inv.balance ?? 0) > 0
    )
    .reduce((sum, inv) => {
      const bal = inv.balance ?? 0;
      if (bal <= 0) return sum;
      if (inv.currency === 'USD' && inv.exchange_rate) {
        return sum + bal * inv.exchange_rate;
      }
      return sum + bal;
    }, 0);
}
